module.exports = __webpack_public_path__ + "assets/logo-gold-extended.f9cba216.svg";